var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import _ from 'lodash';
import { Component, Prop } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import draggable from 'vuedraggable';
import PageService from '../../api/PageService';
var KeyConfig = (function (_super) {
    __extends(KeyConfig, _super);
    function KeyConfig() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.visible = false;
        _this.configData = [];
        return _this;
    }
    KeyConfig.prototype.created = function () {
        this.service = PageService.getInstance();
    };
    KeyConfig.prototype.onMove = function (e) {
        if (e.relatedContext.element.fixed)
            return false;
        return true;
    };
    KeyConfig.prototype.confirm = function () {
        var _this = this;
        var data = this.configData.map(function (item, index) {
            item.sort = index + 1;
            return item;
        });
        var params = {
            template_type: this.templateType,
            data: JSON.stringify(data),
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .updatePage(params)
            .then(function (res) {
            loadingInstance.close();
            _this.$message.success(res.msg || '更新成功');
            _this.hide();
            _this.$emit('configUpdate', data);
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    KeyConfig.prototype.show = function (configData, templateType) {
        this.configData = _.cloneDeep(configData);
        this.templateType = templateType;
        this.visible = true;
    };
    KeyConfig.prototype.hide = function () {
        this.visible = false;
    };
    KeyConfig.prototype.freezeClick = function (row, rowIndex) {
        row.is_freeze = row.is_freeze ? 0 : 1;
        this.configData.map(function (item, index) {
            item.fixed = row.is_freeze && index <= rowIndex;
            if (rowIndex !== index)
                item.is_freeze = item.key === row.key ? 1 : 0;
        });
    };
    __decorate([
        Prop({
            default: false,
        })
    ], KeyConfig.prototype, "isMultiHeader", void 0);
    __decorate([
        Prop({
            default: 5
        })
    ], KeyConfig.prototype, "fixedLimit", void 0);
    KeyConfig = __decorate([
        Component({
            components: {
                draggable: draggable,
            },
        })
    ], KeyConfig);
    return KeyConfig;
}(Vue));
export default KeyConfig;
